import {createInstance as _createInstance, setOverrides} from '@dbp-toolkit/common/i18next.js';

import de from './i18n/de/dbp-auth.json';
import en from './i18n/en/dbp-auth.json';

export function createInstance() {
    return _createInstance({en: en, de: de}, 'de', 'en', 'dbp-auth');
}

export {setOverrides};